<script setup lang="ts">
import { useErhlLoanAppProcess } from '@/helpers/useErhlLoanAppProcess';
import { onBeforeMount } from 'vue';
const { send } = useErhlLoanAppProcess();

onBeforeMount(() => {
  send('READY');
});
</script>

<template>
  <div></div>
</template>
